import * as React from 'react';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { SiteSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { SiteSettingsSpace } from './SiteSettingsSpace';

export interface SiteSettingsSpaceProviderProps extends ReactDirectiveProps {
  readonly urls: SpacesSiteUrls;
  readonly subspaceName: SiteSettingsSubspaceName;
}

export function SiteSettingsSpaceProvider(props: SiteSettingsSpaceProviderProps) {
  const spaceInfo: SpaceInfo = {
    spaceType: 'sitesettings',
    subspaceName: props.subspaceName,
    item: SpaceItemForNonEntitySpace
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <SiteSettingsSpace {...props} />
    </ConnectedSpaceInfoProvider>
  );
}
